/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Add_MeetingInputs */



/**
* | output |
* | --- |
* | "Add conversation" |
*
* @param {Agenda_Add_MeetingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_add_meeting = /** @type {((inputs?: Agenda_Add_MeetingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Add_MeetingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprek toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une conversation")
	return /** @type {LocalizedString} */ ("Add conversation")
});